/**
 * Admin Video Management — `/admin/videos`
 *
 * @kit-router admin
 *
 * Inventory + ops over rendered videos. Backed by the catch-all `admin` tRPC router
 * (`api.admin.apiGetAllVideos`, `regenerateSceneImages`, `renderVideo`, etc.) — not a
 * dedicated `adminVideos` router. The annotation tells kit-vidmax-admin to resolve
 * to that router for `call`/`api`/`bulk` parity.
 */
import { createFileRoute } from "@tanstack/react-router"
import type { ReactElement } from "react"
import { SuperAdminLayout } from "~/layouts/SuperAdminLayout"
import { AdminVideoList } from "~/components/Admin/AdminVideoList"
import CustomHead from "~/components/SEOHead/CustomHead"
import { AixContentHeader } from "@aix/ui"

function AdminContent() {
  return (
    <>
      <CustomHead />
      <div className="container mx-auto space-y-6">
        <AixContentHeader className="px-8 pt-8">
          <h1 className="text-2xl font-bold">All Videos</h1>
        </AixContentHeader>
        <AdminVideoList />
      </div>
    </>
  )
}

function AdminContentWrapper() {
  return (
    <SuperAdminLayout>
      <AdminContent />
    </SuperAdminLayout>
  )
}

export const Route = createFileRoute("/admin/videos")({
  component: AdminContentWrapper,
})
